import { createSlice } from '@reduxjs/toolkit';

const intialStyle = {
  lineSize: 2,
  lineColor: '#030303',
  textSize: 10,
  textColor: '#030303',
  textStyle: null
}

const initialLine = {
  measurements: [],
  widthInPx: 0,
  heightInPx: 0,
}

const initialState = {
  imageMeasurementData: null,
  isMeasureToolActive: false,
  measureToolStyle: intialStyle,
  allLineValues: initialLine,
  addLineClicked: false,
  isStampingAllowed: false,
  measureToolLoading: false,
  showUnit: true,
  unitValue: null,
  isPassChangedToPostEdit: false,
  lastClickedIsReset: false
};

const measureTool = createSlice({
  name: 'measureTool',
  initialState: initialState,
  reducers: {
    resetState: (state) => {
      state.imageMeasurementData = null;
      state.isMeasureToolActive = false;
      state.measureToolStyle = intialStyle;
      state.allLineValues = initialLine;
      state.addLineClicked = false;
    },
    setImageMeasurementData: (state, { payload }) => {
      state.imageMeasurementData = payload;
    },
    setIsMeasureToolActive: (state, { payload }) => {
      state.isMeasureToolActive = payload;
    },
    setMeasureToolStyle: (state, { payload }) => {
      state.measureToolStyle = payload;
    },
    setAllLineValues: (state, { payload }) => {
      state.allLineValues = payload;
    },
    setAddLineClicked: (state, { payload }) => {
      state.addLineClicked = payload;
    },
    setIsStampingAllowed: (state, { payload }) => {
      state.isStampingAllowed = payload;
    },
    setMeasureToolLoading: (state, { payload }) => {
      state.measureToolLoading = payload;
    },
    setShowUnit: (state, { payload }) => {
      state.showUnit = payload;
    },
    setUnitValue: (state, { payload }) => {
      state.unitValue = payload;
    },
    setIsPassChangedToPostEdit: (state, { payload }) => {
      state.isPassChangedToPostEdit = payload;
    },
    setLastClickedIsReset: (state, { payload }) => {
      state.lastClickedIsReset = payload;
    }
  },
});

export const measureToolActions = measureTool.actions;
export const measureToolSelector = (state) => state.measureTool;
export const measureToolReducer = measureTool.reducer;
export default measureToolReducer;

export const selectImageMeasurementData = (state) => state.measureTool.imageMeasurementData;
export const selectIsMeasureTool = (state) => state.measureTool.isMeasureToolActive;
export const selectMeasureToolStyle = (state) => state.measureTool.measureToolStyle;
export const selectAllLineValues = (state) => state.measureTool.allLineValues;
export const selectAddLineClicked = (state) => state.measureTool.addLineClicked;
export const selectIsStampingAllowed = (state) => state.measureTool.isStampingAllowed;
export const selectMeasureToolLoading = (state) => state.measureTool.measureToolLoading;
export const selectShowUnit = (state) => state.measureTool.showUnit;
export const selectUnitValue = (state) => state.measureTool.unitValue;
export const selectIsPassChangedToPostEdit = (state) => state.measureTool.isPassChangedToPostEdit;
export const selectLastClickIsReset = (state) => state.measureTool.lastClickedIsReset;
